import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Register } from '../register';
import { Login } from '../login';
import { KbaAuthRetry } from '../kbaAuthRetry';
import { ForgotPassword } from '../forgotPassword';
import { OtpVerify } from '../otpVerify/otpVerify';
import { PasswordReset } from '../passwordReset/passwordReset';
import { EmailVerify } from '../emailVerify/emailVerify';

export { AccountLayout };

function AccountLayout() {
    const auth = useSelector((x) => x.auth.value);

    // redirect to home if already logged in
    if (auth) {
        return <Navigate to='/' />;
    }

    return (
        <div style={{ maxWidth: '850px' }} className='mx-auto mt-md-5'>
            <Routes>
                <Route path='login' element={<Login />} />
                <Route path='register' element={<Register />} />
                <Route path='kba-authentication' element={<KbaAuthRetry />} />
                <Route path='forgot-password' element={<ForgotPassword />} />
                <Route path='password-reset' element={<PasswordReset />} />
                <Route path='otp-verify' element={<OtpVerify />} />
                <Route path='email-verify' element={<EmailVerify />} />
            </Routes>
        </div>
    );
}
